/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * techcompare-service.ts  2026-08-26T09:15:21+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { TechCompareRecResp, TechServiceStatusResp, TechServiceStatusReq, TechCompareRecReq } from './wy-dto'

const _ = 'TechCompare/'

export class TechCompareService {
  constructor(readonly r: RpcService) {}
  // 技师对比推荐技师
  getTechCompareRec(d: TechCompareRecReq, m?: M): R<TechCompareRecResp> {
    return this.r.async(_ + 'getTechCompareRec', d, m)
  }
  // 获取技师当前服务状态
  getTechServiceStatus(d: TechServiceStatusReq, m?: M): R<TechServiceStatusResp> {
    return this.r.async(_ + 'getTechServiceStatus', d, m)
  }
}
